import { usePaymentContext } from "../context/TPaymentContext";
import { useContext, useEffect, useRef, useState } from "react";
import { TOContext } from "../context/TContext";


export const useCreditCardForwardForm = (handleCardError, setTokenForward) => {
  const { paymentIntent, setForwardPaymentMethod, setForwardTokenizeLoading } =
    usePaymentContext();
  const { CREDIT_CARD, payWithCreditCard } = useContext(TOContext);
  const [formMounted, setFormMounted] = useState(true);
  const [loading, setLoading] = useState(true);
  const ref = useRef();
  useEffect(() => {
    let observer;
    const formElement = document.getElementById("card-form");
    if (formElement) {
      observer = new MutationObserver((mutations) => {
        for (let mutation of mutations) {
          if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach((node) => {
              if (node.tagName === "IFRAME") {
                node.addEventListener("load", () => {
                  setLoading(false); // Set loading to false when iframe has fully loaded
                });
                observer.disconnect(); // Optionally disconnect after finding the iframe
              }
            });
          }
        }
      });

      observer.observe(formElement, {
        childList: true, // Observe direct children
        subtree: true, // Observe deeper descendants
      });
    }

    return () => observer && observer.disconnect();
  }, []);

  // Initialize and mount the card element once the script is loaded
  useEffect(() => {
    const initializeCardElement = async () => {
      if (!paymentIntent) {
        return;
      }
      setFormMounted(false);
      const windowWithForward = window;
      if (!windowWithForward?.Forward) {
        console.error("Forward SDK is not available");
        return;
      }
      const cardElement = await windowWithForward.Forward.createCardElement({
        apiKey: process.env.REACT_APP_FORWARD_KEY || "",
        clientSecret: paymentIntent,
      });
      const el = document.getElementById("card-form");
      const childLength = el?.childNodes?.length;
      if (!childLength && windowWithForward.Forward) {
        cardElement.mount("#card-form", {
          onReady: (tokenize) => {
            setForwardTokenizeLoading(true);
            tokenize();
          },
          onChange: (event) => {
            if (!event.ready) {
              handleCardError(true);
            }
            if (event.ready) {
              setForwardPaymentMethod({ card: event.card });
            }
          },
          onSuccess: (data) => {
            handleCardError(false);
            console.log(data, 'data');
            const { token } = data;
            setForwardTokenizeLoading(false);
            setTokenForward(token);
          },
          onError: () => {
            handleCardError(true);
            setForwardPaymentMethod("");
          },
          onCancel: () => {
            console.log("User cancelled the payment");
          },
          showLabels: false,
        });
      }
    };

    if (typeof document !== "undefined") {
      const formContainer = ref.current;
      if (
        formContainer &&
        !formContainer.hasChildNodes() &&
        paymentIntent &&
        formMounted
      ) {
        initializeCardElement().then(() => { });
      }
    }
  }, [
    paymentIntent,
    formMounted,
    handleCardError,
    setForwardPaymentMethod,
    setTokenForward,
    payWithCreditCard,
  ]);

  return {
    loading,
    payWithCreditCard,
    CREDIT_CARD,
    ref,
  }
}